import React from "react";
import { WorkOrderFormPage } from "./WorkOrder";
import StitchWorkOrderDetailPage from "./StitchWorkOrderDetailPage";
import WorkOrderPrint from "./Print";
import { StitchFormShell } from "../../../../shared-ui/StitchFormShell";

export function StitchWorkOrderFormPage() {
  return (
    <StitchFormShell
      crumbs={["Operations", "ZOrder", "Work Order"]}
      title="Work order form"
      description="Create or edit a work order. Totals and line items come from live APIs."
    >
      <WorkOrderFormPage />
    </StitchFormShell>
  );
}

export function StitchWorkOrderPrintPage() {
  return (
    <StitchFormShell
      crumbs={["Operations", "ZOrder", "Work Order Print"]}
      title="Work order document"
      description="Printable work order from live data."
      print
    >
      <WorkOrderPrint />
    </StitchFormShell>
  );
}

export { StitchWorkOrderDetailPage };
export default StitchWorkOrderFormPage;
